import {useEffect, useMemo} from "react";
import {WavRecorder, ChunkProcessor} from "../../../../libs/wavtools";
import {useInputDevice} from "../InputDeviceContext";

export function useWavRecorder() {
    const wavRecorder = useMemo(() => new WavRecorder({ sampleRate: 24000 }), []);
    const [inputDevice] = useInputDevice();

    const start = async (callback: ChunkProcessor) => {
        await wavRecorder.begin(inputDevice?.deviceId);
        await wavRecorder.clear();
        await wavRecorder.record(callback);
    };

    const stop = async () => {
        if (wavRecorder.getStatus() !== "ended") {
            await wavRecorder.end();
        }
    };

    const listDevices = () => {
        return wavRecorder.listDevices();
    }

    useEffect(() => {
        return () => {
            stop();
        };
    }, []);

    return { start, stop, listDevices };
}
